import axios from 'axios';
import authHeader from 'shared/authHeader';

class FileService {

	static getSignedUrlpdf_GET(id, title) {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await axios.get(
					`${process.env.REACT_APP_URL}/api/file/pdf/assignment/get?id=${id}&title=${title}`,
					{
						headers: authHeader()
					}
				);
				resolve(res.data)
			} catch (e) {
				reject(e)
			}
		});
	}

	static getSignedUrlpdfValidated_GET(id, title, ref = null) {
		return new Promise(async (resolve, reject) => {
			const refText = ref ? `&ref=${ref}` : '';
			try {
				const res = await axios.get(
					`${process.env.REACT_APP_URL}/api/file/pdf/assignment/getValidated?id=${id}&title=${title}${refText}`,
					{
						headers: authHeader()
					}
				);
				resolve(res.data)
			} catch (e) {
				reject(e)
			}
		});
	}

	static getSignedUrlVideo_GET(id, title, ref = null) {
		return new Promise(async (resolve, reject) => {
			const refText = ref ? `&ref=${ref}` : '';

			//Backend will have this logic
			//const ampersand = title ? title.indexOf('&') : -2;
			//const url = `${process.env.REACT_APP_URL}/api/file/video/assignment/get?${ampersand === -1 ? `title=${title}` : `id=${id}`}${refText}`;

			const url = `${process.env.REACT_APP_URL}/api/file/video/assignment/get?id=${id}${refText}`;
			try {
				const { data } = await axios.get(url, {
					headers: authHeader()
				});
				resolve(data);
			} catch (e) {
				console.error('error getting assignment', e)
				reject(e)
			}
		})
	}

	static getAuthPlayVideo(id) {
		return new Promise(async (resolve, reject) => {
			const url = `${process.env.REACT_APP_URL}/api/file/video/assignment/getauth?id=${id}`;
			//console.log('getAuthPlayVideo using url', url)
			try {
				const { data } = await axios.get(url, {
					headers: authHeader()
				});
				//console.log('got data', data)
				resolve(data);
			} catch (e) {
				console.error('error getting getAuthPlayVideo', e)
				reject(e)
			}
		})
	}

	static formlinkPing(id) {
		return new Promise(async (resolve, reject) => {
			const url = `${process.env.REACT_APP_URL}/api/file/formlink/ping?id=${id}`;
			//console.log('formlink ping using id', id)
			try {
				await axios.get(url, {
					headers: authHeader()
				});
				resolve();
			} catch (e) {
				console.error('error sending formlink ping', e)
				reject(e)
			}
		})
	}
	

	static getSignedCookie(ref = null) {
		return new Promise(async (resolve, reject) => {
			try {
				const refText = ref == null ? '' : '?ref=' + ref
				const res = await axios.get(`${process.env.REACT_APP_URL}/api/file/video/assignment/cookie${refText}`, {
					headers: authHeader(),
					withCredentials: true
				});
				resolve(res.data)
			} catch (e) {
				reject(e)
			}
		})
	}

}

export default FileService;
